module.exports = __webpack_public_path__ + "static/media/SH2.a3e4cefe.jpg";